<div class="subscription-plans-screen">
  <!-- Plans Heading with Offer Banner -->
  <div class="plans-heading">
    <!-- <div class="offer">
      <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_40000187_10956" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="19"
          height="19">
          <rect width="18.5557" height="18.5557" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_40000187_10956)">
          <path
            d="M9.2784 17.0099C8.96914 17.0099 8.67277 16.9519 8.38928 16.836C8.10579 16.72 7.85451 16.5525 7.63545 16.3334C7.26176 15.9597 6.93962 15.7149 6.66901 15.5989C6.39841 15.483 5.9925 15.425 5.4513 15.425C4.807 15.425 4.25935 15.1995 3.80835 14.7485C3.35734 14.2975 3.13184 13.7498 3.13184 13.1055C3.13184 12.5643 3.07385 12.1584 2.95788 11.8878C2.84191 11.6172 2.59707 11.295 2.22338 10.9214C2.00432 10.7023 1.83681 10.451 1.72083 10.1675C1.60486 9.88404 1.54688 9.58766 1.54688 9.2784C1.54688 8.96914 1.60486 8.67277 1.72083 8.38928C1.83681 8.10579 2.00432 7.85451 2.22338 7.63545C2.59707 7.26176 2.84191 6.93962 2.95788 6.66901C3.07385 6.39841 3.13184 5.9925 3.13184 5.4513C3.13184 4.807 3.35734 4.25935 3.80835 3.80835C4.25935 3.35734 4.807 3.13184 5.4513 3.13184C5.9925 3.13184 6.39841 3.07385 6.66901 2.95788C6.93962 2.84191 7.26176 2.59707 7.63545 2.22338C7.85451 2.00432 8.10579 1.83681 8.38928 1.72083C8.67277 1.60486 8.96914 1.54688 9.2784 1.54688C9.58766 1.54688 9.88404 1.60486 10.1675 1.72083C10.451 1.83681 10.7023 2.00432 10.9214 2.22338C11.295 2.59707 11.6172 2.84191 11.8878 2.95788C12.1584 3.07385 12.5643 3.13184 13.1055 3.13184C13.7498 3.13184 14.2975 3.35734 14.7485 3.80835C15.1995 4.25935 15.425 4.807 15.425 5.4513C15.425 5.9925 15.483 6.39841 15.5989 6.66901C15.7149 6.93962 15.9597 7.26176 16.3334 7.63545C16.5525 7.85451 16.72 8.10579 16.836 8.38928C16.9519 8.67277 17.0099 8.96914 17.0099 9.2784C17.0099 9.58766 16.9519 9.88404 16.836 10.1675C16.72 10.451 16.5525 10.7023 16.3334 10.9214C15.9597 11.295 15.7149 11.6172 15.5989 11.8878C15.483 12.1584 15.425 12.5643 15.425 13.1055C15.425 13.7498 15.1995 14.2975 14.7485 14.7485C14.2975 15.1995 13.7498 15.425 13.1055 15.425C12.5643 15.425 12.1584 15.483 11.8878 15.5989C11.6172 15.7149 11.295 15.9597 10.9214 16.3334C10.7023 16.5525 10.451 16.72 10.1675 16.836C9.88404 16.9519 9.58766 17.0099 9.2784 17.0099ZM9.2784 15.4636C9.38149 15.4636 9.48135 15.4411 9.578 15.396C9.67464 15.3509 9.75518 15.2961 9.81961 15.2317C10.3479 14.7034 10.844 14.3458 11.3079 14.1589C11.7718 13.9721 12.371 13.8787 13.1055 13.8787C13.3246 13.8787 13.5082 13.8046 13.6564 13.6564C13.8046 13.5082 13.8787 13.3246 13.8787 13.1055C13.8787 12.3581 13.9721 11.7557 14.1589 11.2983C14.3458 10.8408 14.7034 10.3479 15.2317 9.81961C15.3863 9.66498 15.4636 9.48458 15.4636 9.2784C15.4636 9.07223 15.3863 8.89183 15.2317 8.7372C14.7034 8.20887 14.3458 7.71277 14.1589 7.24888C13.9721 6.78498 13.8787 6.18579 13.8787 5.4513C13.8787 5.23224 13.8046 5.04861 13.6564 4.90042C13.5082 4.75224 13.3246 4.67814 13.1055 4.67814C12.3581 4.67814 11.7557 4.58472 11.2983 4.39788C10.8408 4.21103 10.3479 3.85345 9.81961 3.32513C9.75518 3.2607 9.67464 3.20593 9.578 3.16083C9.48135 3.11573 9.38149 3.09318 9.2784 3.09318C9.17531 3.09318 9.07545 3.11573 8.97881 3.16083C8.88216 3.20593 8.80162 3.2607 8.7372 3.32513C8.20887 3.85345 7.71277 4.21103 7.24888 4.39788C6.78498 4.58472 6.18579 4.67814 5.4513 4.67814C5.23224 4.67814 5.04861 4.75224 4.90042 4.90042C4.75224 5.04861 4.67814 5.23224 4.67814 5.4513C4.67814 6.19868 4.58472 6.80109 4.39788 7.25854C4.21103 7.71599 3.85345 8.20887 3.32513 8.7372C3.1705 8.89183 3.09318 9.07223 3.09318 9.2784C3.09318 9.48458 3.1705 9.66498 3.32513 9.81961C3.85345 10.3479 4.21103 10.844 4.39788 11.3079C4.58472 11.7718 4.67814 12.371 4.67814 13.1055C4.67814 13.3246 4.75224 13.5082 4.90042 13.6564C5.04861 13.8046 5.23224 13.8787 5.4513 13.8787C6.19868 13.8787 6.80109 13.9721 7.25854 14.1589C7.71599 14.3458 8.20887 14.7034 8.7372 15.2317C8.80162 15.2961 8.88216 15.3509 8.97881 15.396C9.07545 15.4411 9.17531 15.4636 9.2784 15.4636ZM11.2113 12.371C11.5334 12.371 11.8073 12.2583 12.0328 12.0328C12.2583 11.8073 12.371 11.5334 12.371 11.2113C12.371 10.8891 12.2583 10.6153 12.0328 10.3898C11.8073 10.1643 11.5334 10.0516 11.2113 10.0516C10.8891 10.0516 10.6153 10.1643 10.3898 10.3898C10.1643 10.6153 10.0516 10.8891 10.0516 11.2113C10.0516 11.5334 10.1643 11.8073 10.3898 12.0328C10.6153 12.2583 10.8891 12.371 11.2113 12.371ZM7.30686 12.3324L12.3324 7.30686L11.2499 6.22445L6.22445 11.2499L7.30686 12.3324ZM7.34552 8.50525C7.66767 8.50525 7.94149 8.3925 8.167 8.167C8.3925 7.94149 8.50525 7.66767 8.50525 7.34552C8.50525 7.02337 8.3925 6.74955 8.167 6.52405C7.94149 6.29854 7.66767 6.18579 7.34552 6.18579C7.02337 6.18579 6.74955 6.29854 6.52405 6.52405C6.29854 6.74955 6.18579 7.02337 6.18579 7.34552C6.18579 7.66767 6.29854 7.94149 6.52405 8.167C6.74955 8.3925 7.02337 8.50525 7.34552 8.50525Z"
            fill="white" />
        </g>
      </svg>
      <span>20% Special Offer Ends in : 10h 12m 24s</span>
    </div> -->

    <h1>{{ "Plan&Price.title" | translate }}</h1>
    <p>{{ "Plan&Price.subtitle" | translate }}</p>

    <!-- Tab Buttons for Monthly/Yearly -->
    <div class="plans-option">
      <button class="btn btn-option" [class.active]="activeTabId === 'monthly'" [disabled]="monthlyPlans.length === 0"
        (click)="selectTab('monthly')">
        {{ "Plan&Price.monthly" | translate }}
      </button>
      <button class="btn btn-option" [class.active]="activeTabId === 'annually'" [disabled]="annualPlans.length === 0"
        (click)="selectTab('annually')">
        {{ "Plan&Price.annual" | translate }} <span>({{ 'subscription-page.up-to-off' | translate }})</span>
      </button>
    </div>
  </div>

  <!-- Renew Button & Countdown Timer Section -->
  <!-- Renew Button -->
  <!-- <div>
      <button 
        *ngIf="user?.premimum_user" 
        class="btn btn-primary px-4 py-2 rounded fw-semibold"
        style="min-width: 180px"
        [disabled]="subscribedPlans?.type?.toLowerCase() === 'free' || (remainingTime && !remainingTime.expired)"
        (click)="renewSubscribtion()">
        {{ "Plan&Price.renew" | translate }}
      </button>
    </div> -->

  <!-- Remaining Time Countdown -->
  <div *ngIf="!isLoadingPlans && remainingTime && !remainingTime.expired" class="countdown-wrapper">
    <!-- Free Plan Timer -->
    <ng-container *ngIf="isFreePlan(); else paidPlanTimer">
      <div class="remaining_days" style="min-width:180px">
        {{ "Plan&Price.remaining" | translate }}
        {{ remainingTime.days | number:'2.0' }}
        {{ "Plan&Price.days" | translate }}
      </div>
    </ng-container>

    <!-- Paid Plans Timer -->
    <ng-template #paidPlanTimer>
      <!-- Yearly Plan -->
      <ng-container
        *ngIf="subscribedPlans && (subscribedPlans.mode === 'annually' || subscribedPlans.mode === 'yearly')">
        <div class="remaining_days" style="min-width:180px">
          {{ "Plan&Price.remaining" | translate }}
          {{ remainingTime.days | number:'2.0' }}
          {{ "Plan&Price.days" | translate }}
        </div>
      </ng-container>

      <!-- Monthly Plan -->
      <ng-container *ngIf="subscribedPlans && subscribedPlans.mode === 'monthly'">
        <div class="remaining_days" style="min-width:180px">
          {{ "Plan&Price.remaining" | translate }}
          {{ remainingTime.days | number:'2.0' }}
          {{ "Plan&Price.days" | translate }}
        </div>
      </ng-container>
    </ng-template>

    <!-- Expiration Date -->
    <div *ngIf="subscribedPlans?.end_date" class="remaining_days" style="min-width:180px;">
      {{ 'subscription-page.expires-on' | translate }} {{ subscribedPlans.end_date | date: 'MMMM d, yyyy' }}
    </div>
  </div>

  <!-- Expired Message -->
  <div *ngIf="!isLoadingPlans && remainingTime?.expired" class="expired-msg">
    ⚠️ {{ 'subscription-page.expired-msg' | translate }}
  </div>

  <!-- Monthly Plans Tab -->
  <div class="row" *ngIf="activeTabId === 'monthly'">
    <div class="col-lg-3" *ngFor="let plan of monthlyPlans">
      <div class="subscription-plan-card" [ngClass]="{ 
       'active': plan?.type === 'gold' || getPlanComparison(plan.id) === 'same' 
     }">
        <div class="card-head">
          <!-- Popular Badge -->
          <div class="popular-tag" *ngIf="plan?.type === 'gold'">
            <span class="badge">{{ 'subscription-page.most-popular' | translate }}</span>
          </div>

          <h6>
            <span *ngIf="getPlanComparison(plan.id) === 'same'">{{ 'Plan&Price.yourCurrentPlan' | translate }}</span>
            <span *ngIf="getPlanComparison(plan.id) !== 'same'">{{ plan.plan_name | titlecase }}</span>
          </h6>

          <!-- Plan Name & Current Badge -->
          <h2>
            <ng-container *ngIf="plan.isEnterprise; else nonEnterprise">
              {{ 'subscription-page.enterprise' | translate }}
            </ng-container>
            <ng-template #nonEnterprise>
              {{ plan.plan_name | titlecase }}
            </ng-template>

          </h2>

          <!-- Price with Discount -->
          <b>
            <ng-container *ngIf="plan.isEnterprise">
              {{ 'subscription-page.contact-us' | translate }}
            </ng-container>
            <ng-container *ngIf="!plan.isEnterprise">
              <ng-container *ngIf="plan?.monthly_price === 0; else showPrice">
                {{ 'subscription-page.free-plan' | translate }}
              </ng-container>
              <ng-template #showPrice>
                <div *ngIf="hasRenewalDiscount(plan, 'monthly'); else regularMonthDiscount" class="plan-price-block">
                  <span class="renew-old-price" *ngIf="shouldShowStrikethrough(plan, 'monthly')">
                    <del>{{ getOriginalPlanAmount(plan, 'monthly') + getEffectiveSdkPrice(plan) }} {{ plan?.currency }}</del>
                  </span>
                  <span class="renew-new-price">
                    {{ getRenewalDiscountAmount(plan, 'monthly') + getEffectiveSdkPrice(plan) }} {{ plan?.currency }}
                    <small class="price-cycle">{{ 'Plan&Price.perMonth' | translate }}</small>
                  </span>
                </div>
                <ng-template #regularMonthDiscount>
                  <span *ngIf="plan.discount_type && plan.discount_value && getDiscountedPrice(getTotalPrice(plan, 'monthly'), plan.discount_type, plan.discount_value) < getTotalPrice(plan, 'monthly'); else noDiscountMonth">
                  <del>{{ getTotalPrice(plan, 'monthly') }} {{ plan?.currency }}</del>
                  <br />
                  {{ getDiscountedPrice(getTotalPrice(plan, 'monthly'), plan.discount_type, plan.discount_value) }}
                  {{ plan?.currency }}
                  <small>{{ 'Plan&Price.perMonth' | translate }}</small>
                </span>
                </ng-template>
                <ng-template #noDiscountMonth>
                  {{ getTotalPrice(plan, 'monthly') }} {{ plan?.currency }}
                  <small>{{ 'Plan&Price.perMonth' | translate }}</small>
                </ng-template>
              </ng-template>
            </ng-container>
          </b>

          <!-- Discount Badge -->
          <!-- <div *ngIf="getPlanComparison(plan.id) !== 'same' && calculateDiscount(plan) as discount"
            style="margin-top: 10px;">
            <span class="badge rounded-pill bg-success fw-semibold pulse"
              *ngIf="plan.discount_type === 'percentage' && getDiscountValue(plan) > 0">
              {{ getDiscountValue(plan) }}% Off
            </span>
            <span class="badge rounded-pill bg-success fw-semibold pulse"
              *ngIf="plan.discount_type === 'fixed' && getDiscountValue(plan) > 0">
              Save {{ getDiscountValue(plan) }} {{ plan.currency }}
            </span>
          </div> -->
        </div>

        <div class="card-inner">
          <!-- Plan Features/Points -->
          <div class="points">
              <div class="point" *ngIf="plan.Contest_allowed">
                <img class="check" src="assets/images/check3.svg" alt="">
                <div class="content">
                  <p>{{ 'subscription-page.contests-allowed' | translate }}</p>
                  <span>{{ plan.Contest_allowed }}</span>
                </div>
              </div>
              <div class="point" *ngIf="plan.Participants !== null && plan.Participants !== undefined">
                <img class="check" src="assets/images/check3.svg" alt="">
                <div class="content">
                  <p>{{ 'subscription-page.participants-per' | translate }}</p>
                  <span>{{ plan.Participants === 0 ? ('subscription-page.unlimited' | translate) : plan.Participants }}</span>
                </div>
              </div>
              <div class="point" *ngIf="plan.Integrated_Contests">
                <img class="check" src="assets/images/check3.svg" alt="">
                <div class="content">
                  <p>{{ 'subscription-page.integrated-contests' | translate }}</p>
                  <span>{{ plan.Integrated_Contests }}</span>
                </div>
              </div>
            <div class="point" *ngIf="plan.Ads_View_Access">
              <img class="check" src="assets/images/check3.svg" alt="">
              <div class="content">
                <p>{{ 'subscription-page.ads-view' | translate }}</p>
              </div>
            </div>
            <div class="point" *ngIf="plan.Support_Access">
              <img class="check" src="assets/images/check3.svg" alt="">
              <div class="content">
                <p>{{ 'subscription-page.priority-support' | translate }}</p>
              </div>
            </div>
              <div class="point" *ngIf="plan.VIP_View">
                <img class="check" src="assets/images/check3.svg" alt="">
                <div class="content">
                  <p>{{ 'subscription-page.vip-contests' | translate }}</p>
                  <span>{{ plan.VIP_View }}</span>
                </div>
              </div>
              <div class="point" *ngIf="plan.report_view">
                <img class="check" src="assets/images/check3.svg" alt="">
                <div class="content">
                  <p>{{ 'subscription-page.report-access' | translate }}</p>
                  <span>{{ plan.report_view }}</span>
                </div>
              </div>
            <div class="point" *ngIf="plan.ai_attributes">
              <img class="check" src="assets/images/check3.svg" alt="">
              <div class="content">
                <p>{{ 'subscription-page.ai-insights' | translate }}</p>
                <span>{{ 'subscription-page.enable' | translate }}</span>
              </div>
            </div>
          </div>
          <!-- Action Button -->
          <div>
            <button class="btn w-100" [ngClass]="{
                'btn-primary': plan.type !== 'gold',
                'btn-warning': plan.type === 'gold',
                'btn-primary-outline': getPlanComparison(plan.id) === 'same' && !shouldShowRenew(plan)
              }" (click)="handleClick(plan)" [disabled]="!shouldShowRenew(plan) && (getPlanComparison(plan.id) === 'same' || (user?.is_free_plan_active && plan?.monthly_price === 0))">
              <ng-container *ngIf="isLoggedIn; else chooseText">
                <ng-container *ngIf="plan.isEnterprise; else nonEnterpriseText">
                  {{ 'subscription-page.contact-us' | translate }}
                </ng-container>
                <ng-template #nonEnterpriseText>
                  {{ getPlanActionLabel(plan) }}
                </ng-template>
              </ng-container>
              <ng-template #chooseText>{{ 'subscription-page.choose' | translate }}</ng-template>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Yearly Plans Tab -->
  <div class="row" *ngIf="activeTabId === 'annually'">
    <div class="col-lg-3" *ngFor="let plan of annualPlans">
      <div class="subscription-plan-card" [ngClass]="{ 
       'active': plan?.type === 'gold' || getPlanComparison(plan.id) === 'same' 
     }">
        <div class="card-head">
          <!-- Popular Badge -->
          <div class="popular-tag" *ngIf="plan?.type === 'gold'">
            <span class="badge">{{ 'subscription-page.most-popular' | translate }}</span>
          </div>

          <h6>
            <span *ngIf="getPlanComparison(plan.id) === 'same'">{{ 'Plan&Price.yourCurrentPlan' | translate }}</span>
            <span *ngIf="getPlanComparison(plan.id) !== 'same'">{{ plan.plan_name | titlecase }}</span>
          </h6>

          <!-- Plan Name & Current Badge -->
          <h2>
            <ng-container *ngIf="plan.isEnterprise; else nonEnterprise">
              {{ 'subscription-page.enterprise' | translate }}
            </ng-container>
            <ng-template #nonEnterprise>
              {{ plan.plan_name | titlecase }}
            </ng-template>

          </h2>

          <!-- Price with Discount -->
          <b>
            <ng-container *ngIf="plan.isEnterprise">
              {{ 'subscription-page.contact-us' | translate }}
            </ng-container>
            <ng-container *ngIf="!plan.isEnterprise">
              <ng-container *ngIf="plan?.yearly_price === 0; else showYearPrice">
                {{ 'subscription-page.free-plan' | translate }}
              </ng-container>
              <ng-template #showYearPrice>
                <div *ngIf="hasRenewalDiscount(plan, 'yearly'); else regularYearDiscount" class="plan-price-block">
                  <span class="renew-old-price" *ngIf="shouldShowStrikethrough(plan, 'yearly')">
                    <del>{{ getOriginalPlanAmount(plan, 'yearly') + getEffectiveSdkPrice(plan) }} {{ plan?.currency }}</del>
                  </span>
                  <span class="renew-new-price">
                    {{ getRenewalDiscountAmount(plan, 'yearly') + getEffectiveSdkPrice(plan) }} {{ plan?.currency }}
                    <small class="price-cycle">{{ 'Plan&Price.perYear' | translate }}</small>
                  </span>
                </div>
                <ng-template #regularYearDiscount>
                  <span *ngIf="plan.discount_type && plan.discount_value && getDiscountedPrice(getTotalPrice(plan, 'yearly'), plan.discount_type, plan.discount_value) < getTotalPrice(plan, 'yearly'); else noDiscount">
                  <del>{{ getTotalPrice(plan, 'yearly') }} {{ plan?.currency }}</del>
                  <br />
                  {{ getDiscountedPrice(getTotalPrice(plan, 'yearly'), plan.discount_type, plan.discount_value) }}
                  {{ plan?.currency }}
                  <small>{{ 'Plan&Price.perYear' | translate }}</small>
                </span>
                </ng-template>
                <ng-template #noDiscount>
                  {{ getTotalPrice(plan, 'yearly') }} {{ plan?.currency }}
                  <small>{{ 'Plan&Price.perYear' | translate }}</small>
                </ng-template>
              </ng-template>
            </ng-container>
          </b>

          <!-- Discount Badge -->
          <!-- <div *ngIf="getPlanComparison(plan.id) !== 'same' && calculateDiscount(plan) as discount"
            style="margin-top: 10px;">
            <span class="badge rounded-pill bg-success fw-semibold pulse"
              *ngIf="plan.discount_type === 'percentage' && getDiscountValue(plan) > 0">
              {{ getDiscountValue(plan) }}% Off
            </span>
            <span class="badge rounded-pill bg-success fw-semibold pulse"
              *ngIf="plan.discount_type === 'fixed' && getDiscountValue(plan) > 0">
              Save {{ getDiscountValue(plan) }} {{ plan.currency }}
            </span>
          </div> -->
        </div>

        <div class="card-inner">
          <!-- Plan Features/Points -->
          <div class="points">
              <div class="point" *ngIf="plan.Contest_allowed">
                <img class="check" src="assets/images/check3.svg" alt="">
                <div class="content">
                  <p>{{ 'subscription-page.contests-allowed' | translate }}</p>
                  <span>{{ plan.Contest_allowed }}</span>
                </div>
              </div>
              <div class="point" *ngIf="plan.Participants !== null && plan.Participants !== undefined">
                <img class="check" src="assets/images/check3.svg" alt="">
                <div class="content">
                  <p>{{ 'subscription-page.participants-per' | translate }}</p>
                  <span>{{ plan.Participants === 0 ? ('subscription-page.unlimited' | translate) : plan.Participants }}</span>
                </div>
              </div>
              <div class="point" *ngIf="plan.Integrated_Contests">
                <img class="check" src="assets/images/check3.svg" alt="">
                <div class="content">
                  <p>{{ 'subscription-page.integrated-contests' | translate }}</p>
                  <span>{{ plan.Integrated_Contests }}</span>
                </div>
              </div>
            <div class="point" *ngIf="plan.Ads_View_Access">
              <img class="check" src="assets/images/check3.svg" alt="">
              <div class="content">
                <p>{{ 'subscription-page.ads-view' | translate }}</p>
              </div>
            </div>
            <div class="point" *ngIf="plan.Support_Access">
              <img class="check" src="assets/images/check3.svg" alt="">
              <div class="content">
                <p>{{ 'subscription-page.priority-support' | translate }}</p>
              </div>
            </div>
              <div class="point" *ngIf="plan.VIP_View">
                <img class="check" src="assets/images/check3.svg" alt="">
                <div class="content">
                  <p>{{ 'subscription-page.vip-contests' | translate }}</p>
                  <span>{{ plan.VIP_View }}</span>
                </div>
              </div>
              <div class="point" *ngIf="plan.report_view">
                <img class="check" src="assets/images/check3.svg" alt="">
                <div class="content">
                  <p>{{ 'subscription-page.report-access' | translate }}</p>
                  <span>{{ plan.report_view }}</span>
                </div>
              </div>
            <div class="point" *ngIf="plan.ai_attributes">
              <img class="check" src="assets/images/check3.svg" alt="">
              <div class="content">
                <p>{{ 'subscription-page.ai-insights' | translate }}</p>
                <span>{{ 'subscription-page.enable' | translate }}</span>
              </div>
            </div>
          </div>

          <!-- Action Button -->
          <div>
            <button class="btn w-100" [ngClass]="{
                'btn-primary': plan.type !== 'gold',
                'btn-warning': plan.type === 'gold',
                'btn-primary-outline': getPlanComparison(plan.id) === 'same' && !shouldShowRenew(plan)
              }" (click)="handleClick(plan)" [disabled]="!shouldShowRenew(plan) && (getPlanComparison(plan.id) === 'same' || (user?.is_free_plan_active && plan?.monthly_price === 0))">
              <ng-container *ngIf="isLoggedIn; else chooseText">
                <ng-container *ngIf="plan.isEnterprise; else nonEnterpriseText">
                  {{ 'subscription-page.contact-us' | translate }}
                </ng-container>
                <ng-template #nonEnterpriseText>
                  {{ getPlanActionLabel(plan) }}
                </ng-template>
              </ng-container>
              <ng-template #chooseText>{{ 'subscription-page.choose' | translate }}</ng-template>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>


  <nz-modal [(nzVisible)]="isVisible" [nzCentered]="true" [nzFooter]="null" (nzOnCancel)="handleCancel()"
    nzClassName="pricing-modal">
    <ng-container *nzModalContent>
      <!-- Downgrade Modal Content -->
      <div *ngIf="planChangeType === 'downgrade'" class="downgrade-modal">
        <h5>{{ 'Plan&Price.downgradeBtn' | translate }} {{ 'common.to' | translate }} {{ selectedPlan?.plan_name || 'Free' }}</h5>
        <p>
          {{ 'subscription-page.plan-downgrade-to' | translate }}
          <b>{{ selectedPlan?.plan_name || selectedPlan?.type | titlecase }}</b>
          {{ 'subscription-page.on-next-billing' | translate }} <b>{{ subscribedPlans?.end_date | date: 'MMMM d, yyyy' }}</b>.
          <span *ngIf="selectedPlan?.price > 0">
            {{ 'subscription-page.new-payment-prefix' | translate }} {{ selectedPlan?.mode === 'monthly' ? ('subscription-page.monthly' | translate) : ('subscription-page.yearly' | translate) }} {{ 'subscription-page.payment-will-be' | translate }}
            <b>{{ selectedPlan?.price }} {{ selectedPlan?.currency || 'USD' }}</b>.
          </span>
          <span *ngIf="selectedPlan?.price === 0">
            {{ 'subscription-page.free-plan-no-charge' | translate }}
          </span>
        </p>
        <div class="bottom-btns">
          <button class="btn btn-cancel" (click)="handleCancel()">{{ 'subscription-page.cancel' | translate }}</button>
          <button class="btn btn-downgrade" (click)="handleOk()">{{ 'Plan&Price.downgradeBtn' | translate }}</button>
        </div>
      </div>

      <!-- Upgrade Modal Content -->
      <div *ngIf="planChangeType === 'upgrade'" class="upgrade-modal">
        <h5>{{ 'Plan&Price.upgradeBtn' | translate }} {{ 'common.to' | translate }} {{ selectedPlan?.plan_name || 'Premium' }}</h5>
        <p>
          {{ 'subscription-page.plan-upgrade-to' | translate }}
          <b>{{ selectedPlan?.plan_name || selectedPlan?.type | titlecase }}</b>
          {{ 'subscription-page.on-next-billing' | translate }} <b>{{ subscribedPlans?.end_date | date: 'MMMM d, yyyy' }}</b>.
          {{ 'subscription-page.new-payment-prefix' | translate }} {{ selectedPlan?.mode === 'monthly' ? ('subscription-page.monthly' | translate) : ('subscription-page.yearly' | translate) }} {{ 'subscription-page.payment-will-be' | translate }}
          <b>{{ selectedPlan?.price }} {{ selectedPlan?.currency || 'USD' }}</b>.
        </p>
        <div class="bottom-btns">
          <button class="btn btn-cancel" (click)="handleCancel()">{{ 'subscription-page.cancel' | translate }}</button>
          <button class="btn btn-downgrade" (click)="handleOk()">{{ 'Plan&Price.upgradeBtn' | translate }}</button>
        </div>
      </div>

      <!-- Default Content (if planChangeType is empty) -->
      <div *ngIf="!planChangeType" class="default-modal">
        <h5>{{ 'subscription-page.plan-change' | translate }}</h5>
        <p>
          {{ 'subscription-page.plan-changed-to' | translate }}
          <b>{{ selectedPlan?.plan_name || selectedPlan?.type | titlecase }}</b>
          {{ 'subscription-page.on-next-billing' | translate }} <b>{{ subscribedPlans?.end_date | date: 'MMMM d, yyyy' }}</b>.
        </p>
        <div class="bottom-btns">
          <button class="btn btn-cancel" (click)="handleCancel()">{{ 'subscription-page.cancel' | translate }}</button>
          <button class="btn btn-downgrade" (click)="handleOk()">{{ 'subscription-page.proceed' | translate }}</button>
        </div>
      </div>
    </ng-container>
  </nz-modal>

  <nz-modal [(nzVisible)]="renewModal" [nzCentered]="true" [nzFooter]="null" nzClassName="pricing-modal"
    (nzOnCancel)="handleRenewCancel()">
    <ng-container *nzModalContent>
      <div class="upgrade-modal">
        <h5>{{ 'subscription-page.renew-modal-title' | translate }} {{ subscribedPlans?.type | titlecase }}</h5>
        <p>
          {{ 'subscription-page.renew-modal-desc' | translate }}
          <b>{{ subscribedPlans?.type | titlecase }}</b>
          ({{ subscribedPlans?.mode }}).
          <br />
          {{ 'subscription-page.renew-modal-confirm' | translate }}
        </p>
        <div class="bottom-btns">
          <button class="btn btn-cancel" (click)="handleRenewCancel()">{{ 'subscription-page.cancel' | translate }}</button>
          <button class="btn btn-downgrade" (click)="handleRenewOk()">{{ 'subscription-page.renew' | translate }}</button>
        </div>
      </div>
    </ng-container>
  </nz-modal>

  <nz-modal [(nzVisible)]="isPaymentModal" nzClassName="pricing-modal" nzMaskClosable="false" [nzFooter]="null"
    [nzWidth]="'900px'" [nzCentered]="true" [nzOkDisabled]="!agreeTerms" [nzClosable]="true" (nzOnCancel)="isPaymentModal = false">
    <ng-container *nzModalContent>
      <div class=" upgrade-modal">
        <div class="payment-container">
          <div class="payment-header">
            <h3 class="mb-2">{{ 'subscription-page.select-payment' | translate }}</h3>
            <p class="text-muted mb-4">
              {{ 'subscription-page.select-payment-desc' | translate }}
            </p>
          </div>
          <div id="paymentForm" class="row d-flex align-items-stretch">
            <!-- Cash Payment Option -->
            <div class="col-md-6">
              <div class="payment-option mb-2">
                <input type="radio" class="btn-check" name="paymentMethod" id="cashPayment" value="cash"
                  [(ngModel)]="selectedPaymentMethod" />
                <label class="btn payment-btn w-100" [ngClass]="{ active: selectedPaymentMethod === 'cash' }"
                  for="cashPayment">
                  <div class="d-flex align-items-center">
                    <div class="payment-icon">
                      <i class="fas fa-money-bill-wave"></i>
                    </div>
                    <div class="payment-details flex-grow-1">
                      <h5 class="mb-1">{{ 'subscription-page.cash-payment' | translate }}</h5>
                      <p class="mb-0 text-muted">
                        {{ 'subscription-page.cash-payment-desc' | translate }}
                      </p>
                    </div>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28" color="#007bff"
                    fill="none">
                    <path d="M9 13C9 13 10 13 11 15C11 15 14.1765 10 17 9" stroke="#007bff" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round"></path>
                    <path
                      d="M21 11.1833V8.28029C21 6.64029 21 5.82028 20.5959 5.28529C20.1918 4.75029 19.2781 4.49056 17.4507 3.9711C16.2022 3.6162 15.1016 3.18863 14.2223 2.79829C13.0234 2.2661 12.424 2 12 2C11.576 2 10.9766 2.2661 9.77771 2.79829C8.89839 3.18863 7.79784 3.61619 6.54933 3.9711C4.72193 4.49056 3.80822 4.75029 3.40411 5.28529C3 5.82028 3 6.64029 3 8.28029V11.1833C3 16.8085 8.06277 20.1835 10.594 21.5194C11.2011 21.8398 11.5046 22 12 22C12.4954 22 12.7989 21.8398 13.406 21.5194C15.9372 20.1835 21 16.8085 21 11.1833Z"
                      stroke="#007bff" stroke-width="2" stroke-linecap="round"></path>
                  </svg>
                </label>
              </div>
            </div>

            <!-- Online Payment Option -->
            <div class="col-md-6">
              <div class="payment-option mb-2">
                <input type="radio" class="btn-check" name="paymentMethod" id="onlinePayment" value="online"
                  [(ngModel)]="selectedPaymentMethod" />
                <label class="btn payment-btn w-100" [ngClass]="{ active: selectedPaymentMethod === 'online' }"
                  for="onlinePayment">
                  <div class="d-flex align-items-center">
                    <div class="payment-icon">
                      <i class="fas fa-globe"></i>
                    </div>
                    <div class="payment-details flex-grow-1">
                      <h5 class="mb-1">{{ 'subscription-page.online-payment' | translate }}</h5>
                      <p class="mb-0 text-muted">
                        {{ 'subscription-page.online-payment-desc' | translate }}
                      </p>
                    </div>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28" color="#007bff"
                    fill="none">
                    <path d="M9 13C9 13 10 13 11 15C11 15 14.1765 10 17 9" stroke="#007bff" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round"></path>
                    <path
                      d="M21 11.1833V8.28029C21 6.64029 21 5.82028 20.5959 5.28529C20.1918 4.75029 19.2781 4.49056 17.4507 3.9711C16.2022 3.6162 15.1016 3.18863 14.2223 2.79829C13.0234 2.2661 12.424 2 12 2C11.576 2 10.9766 2.2661 9.77771 2.79829C8.89839 3.18863 7.79784 3.61619 6.54933 3.9711C4.72193 4.49056 3.80822 4.75029 3.40411 5.28529C3 5.82028 3 6.64029 3 8.28029V11.1833C3 16.8085 8.06277 20.1835 10.594 21.5194C11.2011 21.8398 11.5046 22 12 22C12.4954 22 12.7989 21.8398 13.406 21.5194C15.9372 20.1835 21 16.8085 21 11.1833Z"
                      stroke="#007bff" stroke-width="2" stroke-linecap="round"></path>
                  </svg>
                </label>
              </div>
            </div>
          </div>
          <div class="form-check policy-check">
            <div class="circle-checkbox-container">
              <input type="checkbox" id="circle-checkbox1" class="circle-checkbox" [(ngModel)]="agreeTerms" />
              <label for="circle-checkbox1"></label>
            </div>

            <label class="policy-text text-start" for="circle-checkbox1">
              {{ 'subscription-page.agree-policy' | translate }}
              <a (click)="$event.stopPropagation(); openPrivacyPolicy()" class="privacy-link">
                {{ 'subscription-page.privacy-policy' | translate }}
              </a>
              {{ 'common.and' | translate }}
              <a (click)="$event.stopPropagation(); openTermsConditions()" class="privacy-link">
                {{ 'subscription-page.terms-conditions' | translate }}
              </a>.
            </label>
          </div>
          <div class="bottom-btns">
            <!-- Cancel -->
            <button class="btn btn-cancel" (click)="handlePaymentCancel()">
              {{ 'subscription-page.cancel' | translate }}
            </button>

            <!-- OK / Downgrade -->
            <button class="btn btn-downgrade" [disabled]="!agreeTerms" (click)="handlePaymentOk()">
              {{ 'subscription-page.ok' | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </nz-modal>

  <nz-modal [(nzVisible)]="enterprizeModal" (nzOnCancel)="handleEnterprizeCancel()" nzClassName="luqta-custom-modal"
    [nzTitle]="'subscription-page.enterprise-modal-title' | translate" [nzCentered]="true" [nzWidth]="650" [nzFooter]="modalFooter">
    <ng-container *nzModalContent>
      <form [formGroup]="enterprizeForm" class="enterprise-form-grid">
        <input type="hidden" formControlName="plan_id" />
        <div class="form-grid">
          <!-- Name -->
          <div class="form-group">
            <label>{{ 'subscription-page.your-name' | translate }}</label>
            <input class="form-control" nz-input type="text" formControlName="name" [placeholder]="'subscription-page.enter-name' | translate" />
            <div class="error text-danger" *ngIf="
              enterprizeForm.get('name')?.touched &&
              enterprizeForm.get('name')?.invalid
            ">
              <span *ngIf="enterprizeForm.get('name')?.hasError('required')">
                {{ 'subscription-page.required' | translate }}
              </span>
              <span *ngIf="enterprizeForm.get('name')?.hasError('minlength')">
                {{ 'subscription-page.name-min-3' | translate }}
              </span>
            </div>
          </div>

          <!-- Company Name -->
          <div class="form-group">
            <label>{{ 'subscription-page.company-name' | translate }}</label>
            <input class="form-control" nz-input type="text" formControlName="company_name"
              [placeholder]="'subscription-page.enter-company' | translate" />
            <div class="error text-danger" *ngIf="
              enterprizeForm.get('company_name')?.touched &&
              enterprizeForm.get('company_name')?.invalid
            ">
              {{ 'subscription-page.required' | translate }}
            </div>
          </div>
          <!-- Email -->
          <div class="form-group">
            <label>{{ 'subscription-page.email' | translate }}</label>
            <input class="form-control" nz-input type="email" formControlName="email" [placeholder]="'subscription-page.enter-email' | translate" />
            <div class="error text-danger" *ngIf="
              enterprizeForm.get('email')?.touched &&
              enterprizeForm.get('email')?.invalid
            ">
              <span *ngIf="enterprizeForm.get('email')?.hasError('required')">
                {{ 'subscription-page.required' | translate }}
              </span>
              <span *ngIf="enterprizeForm.get('email')?.hasError('email')">
                {{ 'subscription-page.valid-email' | translate }}
              </span>
            </div>
          </div>

          <!-- Phone Number -->
          <div class="form-group">
            <label>{{ 'subscription-page.phone-number' | translate }}</label>
            <input class="form-control" nz-input type="text" formControlName="phone_number"
              [placeholder]="'subscription-page.enter-phone' | translate" />
            <div class="error text-danger" *ngIf="
              enterprizeForm.get('phone_number')?.touched &&
              enterprizeForm.get('phone_number')?.invalid
            ">
              <span *ngIf="enterprizeForm.get('phone_number')?.hasError('required')">
                {{ 'subscription-page.required' | translate }}
              </span>
              <span *ngIf="enterprizeForm.get('phone_number')?.hasError('pattern')">
                {{ 'subscription-page.phone-digits' | translate }}
              </span>
            </div>
          </div>

          <!-- Address -->
          <div class="form-group">
            <label>{{ 'subscription-page.address' | translate }}</label>
            <input class="form-control" nz-input type="text" formControlName="address"
              [placeholder]="'subscription-page.enter-address' | translate" />
            <div class="error text-danger" *ngIf="
              enterprizeForm.get('address')?.touched &&
              enterprizeForm.get('address')?.invalid
            ">
              {{ 'subscription-page.required' | translate }}
            </div>
          </div>
          <!-- Payment Method -->
          <div class="form-group">
            <label>{{ 'subscription-page.preferred-payment' | translate }}</label>
            <nz-select nzShowSearch nzAllowClear [nzPlaceHolder]="'subscription-page.select-payment-method' | translate" nzClassName="custom-select"
              formControlName="payment_method">
              <nz-option nzValue="cash" nzLabel="Cash"></nz-option>
              <nz-option nzValue="online" nzLabel="Online"></nz-option>
            </nz-select>
            <div class="error text-danger" *ngIf="
              enterprizeForm.get('payment_method')?.touched &&
              enterprizeForm.get('payment_method')?.invalid
            ">
              {{ 'subscription-page.required' | translate }}
            </div>
          </div>
          <!-- Details -->
          <div class="form-group full-width">
            <label>{{ 'subscription-page.details' | translate }}</label>
            <textarea class="form-control" nz-input rows="3" formControlName="details"
              [placeholder]="'subscription-page.details-placeholder' | translate"></textarea>
            <div class="error text-danger" *ngIf="
              enterprizeForm.get('details')?.touched &&
              enterprizeForm.get('details')?.invalid
            ">
              {{ 'subscription-page.required' | translate }}
            </div>
          </div>
        </div>
      </form>
    </ng-container>
    <ng-template #modalFooter>
      <button class="btn btn-dark" (click)="handleEnterprizeCancel()">{{ 'subscription-page.cancel' | translate }}</button>
      <button class="btn btn-primary" nzType="primary" [disabled]="enterprizeForm.invalid"
        (click)="handleEnterprizeOk()">{{ 'subscription-page.submit' | translate }}</button>
    </ng-template>
  </nz-modal>

  <nz-modal [(nzVisible)]="isFreePlanModalVisible" [nzCentered]="true" nzWrapClassName="pricing-modal" [nzFooter]="null"
    (nzOnCancel)="handleFreePlanCancel()">
    <ng-container *nzModalContent>
      <div class="downgrade-modal">
        <h5>{{ 'Plan&Price.downgradeBtn' | translate }} {{ 'common.to' | translate }} {{ selectedPlan?.plan_name || 'Free' }}</h5>
        <p>
          {{ 'subscription-page.free-plan-subscribe' | translate }}
          <strong>{{ selectedFreePlan?.plan_name || 'Free' }}</strong> {{ 'subscription-page.plan-suffix' | translate }}
        </p>

        <div class="bottom-btns">
          <!-- Cancel -->
          <button class="btn btn-cancel" (click)="handleFreePlanCancel()">
            {{ 'subscription-page.cancel' | translate }}
          </button>

          <!-- OK / Downgrade -->
          <button class="btn btn-downgrade" (click)="handleFreePlanOk()">
            {{ 'Plan&Price.downgradeBtn' | translate }}
          </button>
        </div>
      </div>
    </ng-container>
  </nz-modal>
</div>

